import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { colors } from "../../utils/variables";
import breakpoints from "../../utils/breakpoints";

const Toggler = styled.button`
  width: 48px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.backgroundColor || colors.salmon};
  border: 0;
  ${breakpoints.medium` 
    cursor: pointer; 
    display: none;
  `}

  span {
    width: 22px;
    height: 2px;
    position: relative;
    margin-bottom: 6px;
    transition: transform 0.3s ease, opacity 0.3s ease;
    background-color: white;
    &:last-child { margin: 0; }
    }
    ${(props) =>
      props.active &&
      css`
        span:first-child { transform: translateY(8px) rotate(45deg); }
        span:nth-child(2) { opacity: 0; }
        span:last-child { transform: translateY(-8px) rotate(-45deg); }
    `}
`;

const MenuToggler = ({ active, toggleMenu, backgroundColor }) => (
  <Toggler onClick={toggleMenu} active={active} $backgroundColor={backgroundColor}>
    <span />
    <span />
    <span />
  </Toggler>
);

MenuToggler.propTypes = {
  active: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string
};

export default MenuToggler;
